import api from './api';
var queryString = (params = {}) => {
    return Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
};
export const getSettings = (params) => {
    return api.get('/v1/cp/settings?' + queryString(params))
}
export const getBankMethods = (params) => {
    return api.get('/v1/cp/settings/' + params)
}

export const getDepositMethods = async () => {
    const response = await api.get('/v1/cp/transactions/deposit/methods');
    // Returns same shape as deposit_methods JSON — [{ icon, name, label, isActive }]
    // isActive is already resolved for this client's entity
    return response.data.data.filter(m => m.isActive);
};